import EscPosEncoder from "esc-pos-encoder";

export async function connectPrinter() {
  const device = await navigator.usb.requestDevice({
    filters: [{ vendorId: 0x04b8 }],
  });
  await device.open();
  if (device.configuration === null) {
    await device.selectConfiguration(1);
  }
  await device.claimInterface(0); // usually interface 0 for these printers
  return device;
}

export async function getAuthorizedPrinter() {
  const devices = await navigator.usb.getDevices();
  console.debug("Authorized USB devices:", devices);
  return devices.find((d) => d.vendorId === 0x04b8);
}

export function getOutEndpoint(device) {
  const iface = device.configuration.interfaces[0];
  const endpoint = iface.alternate.endpoints.find((e) => e.direction === "out");
  return endpoint.endpointNumber;
}

export async function sendToPrinter(device) {
  const endpointNumber = getOutEndpoint(device);

  const encoder = new EscPosEncoder();
  const data = encoder
    .initialize()
    .align("center")
    .text("Galoche & Patin")
    .newline()
    .text("Ticket de réparation")
    .newline()
    .qrcode("https://ton-site.fr/suivi/123", 2, 6, "m")
    .newline()
    .cut()
    .encode();

  await device.transferOut(endpointNumber, data);
}
